'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
// import { toast } from 'react-toastify';
// import axiosInstance from '@/utils/https';
import {
  AiOutlineHome,
  AiOutlineShop,
  AiOutlineThunderbolt,
  AiOutlineStar,
  AiOutlineFile,
  AiOutlineTeam,
  AiOutlineUser,
} from 'react-icons/ai';
import { BiHeart, BiSupport } from 'react-icons/bi';
import { PiHeartFill } from 'react-icons/pi';

export function HeaderNavMenu() {
  const [loading, setLoading] = useState<number | null>(null);
  // const [orderCode, setOrderCode] = useState<string | null>(null);
  //  const [hasLocation, setHasLocation] = useState(false);
  //  const [surveyTitle, setSurveyTitle] = useState<string | null>(null);
  //  const [isClient, setIsClient] = useState(false);
  const pathname = usePathname();

  // useEffect(() => {
  //     //  setIsClient(true);
  //   try {
  //     // Only runs on client side
  //     const outletData = JSON.parse(localStorage.getItem("outlet") || "{}");
  //     const code = outletData.orderCode || outletData.outsetObject?.orderCode;
  //     setOrderCode(code);
  //     setHasLocation(!!code);
  //   } catch (error) {
  //     console.error("Error accessing localStorage:", error);
  //   }
  // }, []);

  // useEffect(()=>{
  //   const fetchLatestSurveyTitle = async()=>{
  //     try {
  //       const response = await axiosInstance.get('api/v1/survey');
  //       if(response.status === 200){
  //         const surveys = response.data;
  //          const latestSurvey = surveys.reduce((prev: any, current: any) => {
  //         return (new Date(prev.createdAt) > new Date(current.createdAt)) ? prev : current;
  //       });

  //       const urlFriendlyTitle = latestSurvey.title
  //        .toLowerCase()
  //        .replace(/\s+/g, '-')
  //        .replace(/[^a-z0-9-]/g, '');
  //        setSurveyTitle(urlFriendlyTitle);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching surveys:', error);

  //     }
  //   }

  //   fetchLatestSurveyTitle();
  // }, []);

  const navItems = [
    {
      url: '/',
      icon: <AiOutlineHome className="w-6 lg:hidden" />,
      name: 'Home',
    },
    {
      url: '/menu',
      icon: <AiOutlineShop className="w-6 lg:hidden" />,
      name: 'Menu',
    },
    // {
    //   url: '/offers',
    //   icon: <AiOutlineThunderbolt className="w-6 lg:hidden" />,
    //   name: 'Offers',
    // },
    // {
    //   url: '/fan-club',
    //   icon: <AiOutlineStar className="w-6 lg:hidden" />,
    //   name: 'Fan Club',
    // },
    // {
    //   url: '/blog',
    //   icon: <AiOutlineFile className="w-6 lg:hidden" />,
    //   name: 'Blog',
    // },
    // {
    //   url: '/about-us',
    //   icon: <AiOutlineTeam className="w-6 lg:hidden" />,
    //   name: 'About Us',
    // },
    {
      url: '/account',
      icon: <AiOutlineUser className="w-6 lg:hidden" />,
      name: 'My Account',
    },
    {
      url: '/support',
      icon: <BiSupport className="w-6 lg:hidden" />,
      name: 'Support',
    },
    // {
    //   url: '/valbox',
    //   icon: <BiHeart className="w-6 lg:hidden" />,
    //   name: '#LoveInABox',
    // },

    // {
    //   url: orderCode && surveyTitle
    //     ? `/surveys/${orderCode.toString().toUpperCase()}/${surveyTitle.toString()}`
    //     : orderCode
    //     ? `/surveys/${orderCode}`
    //     : '#',
    //   icon: <BiSupport className="w-6 lg:hidden" />,
    //   name: 'Survey',
    // },
  ];

  // const handleClick = (index: number) => {
  //   if (!orderCode && navItems[index].name === 'Survey') {
  //     toast.error('Please set your location at the top right corner to take the survey');
  //     return;
  //   }
  //   setLoading(index);
  // };

  return (
    <nav className="grid gap-5 py-5 grid-cols-2 lg:flex lg:items-center font-medium">
      {navItems.map((item, index) => (
        <Link
          href={item.url}
          className={`flex gap-2 justify-between items-center bg-crunchies-white shadow-lg lg:shadow-none p-3 lg:p-2 lg:hover:bg-gray-100 rounded-lg transition-colors duration-200`}
          onClick={() => setLoading(index)}
          key={index}
        >
          <div
            className={`flex gap-2 items-center text-sm lg:text-base 
              ${item.url === '/valbox' ? 'lg:flex lg:w-[11.313rem] lg:h-[2.5rem] lg:rounded-[2.5rem] lg:border-[0.094rem] lg:border-primary-500 lg:text-primary-500 lg:px-2 lg:py-6 justify-center lg:animate-pulse' : ''}
             ${
              item.url === pathname
                ? 'text-crunchies-red'
                : 'text-gray-700 hover:text-crunchies-red'
            }`}
          >
            {item.icon}
            {/* {item.url === '/valbox' && (
              <PiHeartFill className="w-6 hidden lg:block" />
            )} */}
            <div>{item.name}</div>
          </div>
          {loading === index && (
            <div className="flex gap-1">
              <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce"></div>
              <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce delay-75"></div>
              <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce delay-150"></div>
            </div>
          )}
        </Link>
      ))}
    </nav>
  );
}

//   return (
//     <nav className="grid gap-5 py-5 grid-cols-2 lg:flex lg:items-center font-medium">
//       {navItems.map((item, index) => (
//         <Link
//           href={item.url}
//           className={`flex gap-2 justify-between items-center bg-crunchies-white shadow-lg lg:shadow-none p-3 lg:p-2 lg:hover:bg-gray-100 rounded-lg transition-colors duration-200 ${
//             !orderCode && item.name === 'Survey' ? 'opacity-60 cursor-not-allowed' : ''
//           }`}
//           onClick={(e) => {
//             if (!orderCode && item.name === 'Survey') {
//               e.preventDefault();
//             }
//             handleClick(index);
//           }}
//           key={index}
//         >
//           <div
//             className={`flex gap-2 items-center text-sm lg:text-base ${
//               item.url === '/meal-for-dad'
//                 ? 'hidden lg:flex w-[11.313rem] h-[2.5rem] rounded-[2.5rem] border-[0.094rem] px-2 py-6 justify-center'
//                 : ''
//             } ${
//               item.url === pathname
//                 ? 'text-crunchies-red'
//                 : 'text-gray-700 hover:text-crunchies-red'
//             }`}
//           >
//             {item.icon}
//             <div>{item.name}</div>
//           </div>
//           {loading === index && (
//             <div className="flex gap-1">
//               <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce"></div>
//               <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce delay-75"></div>
//               <div className="w-1 h-1 bg-crunchies-red rounded-full animate-bounce delay-150"></div>
//             </div>
//           )}
//         </Link>
//       ))}
//     </nav>
//   );
// }
